const FEA = 'firmaAvanzada';
const FES = 'firmaSimple';

export default {
  FEA,
  FES,
};
